var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  clipPath: "url(#instagram_logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.25 11.25h-12.5a2.5 2.5 0 0 0-2.5 2.5v12.5a2.5 2.5 0 0 0 2.5 2.5h12.5a2.5 2.5 0 0 0 2.5-2.5v-12.5a2.5 2.5 0 0 0-2.5-2.5M20 25a5 5 0 1 1 0-10 5 5 0 0 1 0 10m5.625-9.062a1.563 1.563 0 1 1 0-3.126 1.563 1.563 0 0 1 0 3.126"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 22.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 0a20 20 0 1 0 0 40 20 20 0 0 0 0-40m11.25 26.25a5 5 0 0 1-5 5h-12.5a5 5 0 0 1-5-5v-12.5a5 5 0 0 1 5-5h12.5a5 5 0 0 1 5 5z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "instagram_logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export default SvgInstagramLogo;